/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A1Inputs */

const en_fc_home_faq_a1 = /** @type {(inputs: Fc_Home_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. FilmCraft is free for every platform and open source under MIT or Apache-2.0. There is no subscription, watermark or trial limit.`)
};

/**
* | output |
* | --- |
* | "Yes. FilmCraft is free for every platform and open source under MIT or Apache-2.0. There is no subscription, watermark or trial limit." |
*
* @param {Fc_Home_Faq_A1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a1 = /** @type {((inputs?: Fc_Home_Faq_A1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a1(inputs)
});
export { fc_home_faq_a1 as "fc.home.faq.a1" }